export const UserRole = {
  Admin: 0,
  Collaborator: 1,
  Client: 2,
};

/*
Menu Types:
"menu-default", "menu-sub-hidden", "menu-hidden"
*/
export const defaultMenuType = 'menu-default';

export const subHiddenBreakpoint = 1440;
export const menuHiddenBreakpoint = 768;
export const defaultLocale = 'br';
export const localeOptions = [
  { id: 'en', name: 'English - LTR', direction: 'ltr' },
  { id: 'es', name: 'Español', direction: 'ltr' },
  { id: 'br', name: 'Brasil', direction: 'ltr' },
  { id: 'enrtl', name: 'English - RTL', direction: 'rtl' },
];

export const firebaseConfig = {
  apiKey: "AIzaSyBUr0Jjbci6-rlpJh6-JbjduTUpFuciHqI",
  authDomain: "krl-db.firebaseapp.com",
  projectId: "krl-db",
  storageBucket: "krl-db.appspot.com",
  messagingSenderId: "164316068924",
  appId: "1:164316068924:web:e94e693486509a0784d739"
};

export const adminRoot = '/app';
export const searchPath = `${adminRoot}/#`;
export const servicePath = process.env.REACT_APP_API;

export const currentUser = {
  id: 1,
  title: 'Heicomp',
  img: '/assets/img/profiles/l-1.jpg',
  date: 'Last seen today 15:24',
  role: UserRole.Client,
};

export const themeColorStorageKey = '__theme_selected_color';
export const isMultiColorActive = false;
export const defaultColor = 'light.bluenavy';
export const isDarkSwitchActive = true;
export const defaultDirection = 'ltr';
export const themeRadiusStorageKey = '__theme_radius';
export const isAuthGuardActive = true;
export const colors = [
  'bluenavy',
  'blueyale',
  'blueolympic',
  'greenmoss',
  'greenlime',
  'purplemonster',
  'orangecarrot',
  'redruby',
  'yellowgranola',
  'greysteel',
];
